// extracted by mini-css-extract-plugin
export default {"tag":"MGTag_tag__pHpjp","label":"MGTag_label__v-Qb4","close":"MGTag_close__JAj8P"};